import { FC, useMemo } from 'react';
import { Select, SelectProps } from 'antd';

import { BeneficiaryGroup } from '@/shared/lib/sj-orm/models/beneficiary.dto';

import { useI18nValues } from '../hooks/useI18nValues';

export const SelectBeneficiaryGroup: FC<SelectProps> = ({ placeholder, ...props }) => {
  const value = useI18nValues();

  const options = useMemo(() => {
    return list.map((group) => ({ value: group, label: value.group(group) }));
  }, []);

  return (
    <Select placeholder={placeholder ?? 'Select Group affiliation'} options={options} {...props} />
  );
};

const list = [BeneficiaryGroup.FAMILY, BeneficiaryGroup.FAMILY_CLAN, BeneficiaryGroup.CIRCLE];
